const MiniLoading = ({type = 'accent'}) => {
    return (
        <div className="p-10">
            لطفا کمی صبر کنید ...
        </div>
    );
};

export default MiniLoading;
